/******************************************************************************
 * App configuration
 *****************************************************************************/
export const APP_NAME = "Ableseportal Stadtwerke Wolmirstedt";
export const APP_SHORT_NAME = "Ableseportal";
export const APP_DESCRIPTION =
    "Melden Sie uns einfach online Ihre Zählerstände - schnell, bequem, sicher.";
export const CLIENT_FULL = "Stadtwerke Wolmirstedt GmbH";
export const CLIENT_SHORT = "Stadtwerke Wolmirstedt";
export const FALLBACK_PRECOMMA_DIGITS = 7;
export const URLS = {
    website: "https://stadtwerke-wolmirstedt.de",
    privacy: "https://stadtwerke-wolmirstedt.de/datenschutz.html",
    imprint: "https://stadtwerke-wolmirstedt.de/impressum",
};
export const LENGTH_IMPLAUSIBLE_REASON_OTHER = 200;
export const ERROR_MESSAGES = {
    error429: "😡 Zuviele Anfragen. Bitte versuchen Sie es in Kürze erneut.",
    error500:
        "😓 Beim Verarbeiten Ihrer Anfrage ist ein Fehler aufgetreten. Bitte kontaktieren Sie unseren Kundenservice.",
};
